import type { SupplierReturnAction, SupplierReturnForm } from './contract';
import { purchaseCurrency } from '../purchase-planning/money.ts';

export type ReturnHeaderField = 'supplier_id' | 'warehouse_id' | 'currency' | 'reference' | 'reason';
export type ReturnHeaderErrors = Partial<Record<ReturnHeaderField, string>>;

export function isReturnHeaderAction(action: SupplierReturnAction): boolean {
  return action === 'create' || action === 'adopt' || action === 'edit_details';
}

function chosen(value: unknown): boolean {
  const id = typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value;
  return typeof id === 'number' && Number.isSafeInteger(id) && id > 0;
}

export function returnHeaderErrors(action: SupplierReturnAction, form: SupplierReturnForm): ReturnHeaderErrors {
  const errors: ReturnHeaderErrors = {};
  if (!isReturnHeaderAction(action)) return errors;
  if (action !== 'edit_details') {
    if (!chosen(form.supplier_id)) errors.supplier_id = 'Choose a supplier.';
    if (!chosen(form.warehouse_id)) errors.warehouse_id = 'Choose a warehouse.';
    try { purchaseCurrency(String(form.currency ?? '')); }
    catch { errors.currency = 'Enter a three-letter currency code, such as EUR.'; }
  }
  if (typeof form.reference !== 'string' || !form.reference.trim()) errors.reference = 'Enter a return reference.';
  else if (form.reference.length > 200) errors.reference = 'Use at most 200 characters for the return reference.';
  if (action !== 'create') {
    if (typeof form.reason !== 'string' || !form.reason.trim()) errors.reason = 'Enter a reason for this change.';
    else if (form.reason.length > 1000) errors.reason = 'Use at most 1,000 characters for the reason.';
  }
  return errors;
}
